import styled from "@emotion/styled";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
  TimePicker,
  Upload,
} from "antd";
import Button from "atoms/Button";
import { CALL_API } from "common/API";
import { displayErrorModal } from "common/common";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import { concat, find, get, includes, intersection, result } from "lodash";
import moment from "moment";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import { ReactComponent as Fileupload } from "../../assets/fonts/File_Upload.svg";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setLeaveList } from "redux/actions";
import {
  getAllDepartmentList,
  getClientid,
  getLeaveCategoryList,
  getLeaveList,
  getRoleList,
  getSelectedDepartmentId,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import {
  addDaysinDate,
  getKenyanDateTime,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import { bindActionCreators } from "redux";
import { UploadOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { ButtonFilled } from "reusableComponent/UIButtons";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTranslation } from "react-i18next";

const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 5px !important;
  }
`;
const StyledInput = styled(Input)`
  border-radius: 5px !important;
`;
const StyledTextArea = styled(Input.TextArea)`
  border-radius: 5px !important;
`;
const StyledModal1 = styled(Modal)``;
const StyledModal = styled(Modal)`
  .divstyl {
    display: flex;
    align-items: center;
    justify-content: end;
  }
  .success-modal {
    align-items: center;
    display: flex;
    padding-top: 40px;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
    border-radius: 5px;
    width: 100%;
  }
  .ant-upload {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    font-feature-settings: "tnum";
    outline: 0;
    width: 100%;
    text-align: center;
  }
  .small-text {
    color: #636980 !important;
  }
`;

// Collapse repeated whitespace and trim, since department_name values coming
// from AllDepartmentList are inconsistently formatted (double spaces,
// trailing spaces, e.g. "Executive  Director's Office ").
const normalize = (str = "") => str.replace(/\s+/g, " ").trim();

const departmentCategoryMap = {
  IT: "IT",
  HR: "HR",
  Supervisory: "Supervisory",
  "Occupational Safety & Health (OSH)": "OSH",
};

// Normalize the map's own keys once so lookups are whitespace-safe on both
// sides, regardless of how AllDepartmentList happens to format names.
const normalizedDepartmentCategoryMap = Object.fromEntries(
  Object.entries(departmentCategoryMap).map(([key, value]) => [
    normalize(key),
    value,
  ])
);

const departmentIncidents = {
  IT: [
    "Asset Breakages",
    "Hardware Issues",
    "Software Issues",
    "System Problems",
    "Application Problems",
    "Equipment Malfunctions",
    "Other Technology-Related Incidents",
  ],

  HR: [
    "Employee Relations",
    "Attendance Matters",
    "Leave Matters",
    "Workplace Conduct",
    "Policy-Related Issues",
    "Grievances",
    "Other Human Resource-Related Incidents",
  ],

  OSH: [
    "Workplace Accidents",
    "Workplace Injuries",
    "Unsafe Conditions",
    "Health Hazards",
    "Safety Hazards",
    "Near-Miss Incidents",
    "Other Occupational Safety Incidents",
  ],

  Supervisory: [
    "Operational Issues",
    "Work Performance Concerns",
    "Process Issues",
    "Workflow Issues",
    "Team-Related Matters",
    "Supervisor Intervention Required",
    "Other Supervisory Incidents",
  ],
};

function LeaveForm({
  isModalVisible = false,
  closeModal,
  userInfo,
  userId,
  userList,
  details,
  selectedIncidentId,
  ClientId,
  page = "",
  AllDepartmentList
}) {
  const { t } = useTranslation();

  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo?.userid
  );
  const history = useHistory();

  const userDepartmentid = userInfo?.baseDepartmentId;

  // Org-chart department the user belongs to (kept for reference/display
  // elsewhere) - NOT used directly for incident routing; it's mapped below
  // via departmentCategoryMap into one of the fixed incident categories
  // (IT / HR / OSH / Supervisory).
  const findDepartment = AllDepartmentList?.find(
    (item) => item?.department_id === userDepartmentid
  )?.department_name;

  const category = normalizedDepartmentCategoryMap[normalize(
"Finance and Procurement Department")];
  const IncidentTypeOption = departmentIncidents[category] || [];

  const { TextArea } = Input;
  const containerRef = useRef(null);
  const [showLoader, toggleLoader] = useState(false);
  const [form] = Form.useForm();
  const [fileData, setFileData] = useState([]);
const [incidentTypeOption, setIncidentTypeOption] = useState([]);
  const resetForm = () => {
    form.resetFields();
    setFileData([]);
    form.setFieldsValue({ date: null });
  };
console.log("details", details);
  useEffect(() => {
    if (details && Object.keys(details).length > 0) {
      form.setFieldsValue({

      departmentType: details?.departmentType || "",
        type: details?.type || "",
        incidentlocation: details?.incidentlocation || "",
        date: details?.date
          ? moment(details.date)
          : momentDate(getKenyanDateTime()),
        time: details?.time ? moment(details.time, "HH:mm:ss") : "",
        description: details?.description || "",
        remark: details?.remark || "",
      });

      if (Array.isArray(details.evidence) && details.evidence.length > 0) {
        const extractedFiles = details.evidence.map((file) => ({
          base64: file.base64Data || "",
          fileType: file.contentType || "",
          name: file.fileName,
          url: file.fileUrl,
        }));
        setFileData(extractedFiles);
      }
    }
  }, [details, isModalVisible]);

  const [isSavedModalOpen, setIsSavedModalOpen] = useState(false);

  const getHongKongTime = () => {
    return new Date().toLocaleString("en-US", { timeZone: "Asia/Hong_Kong" });
  };

  const getHongKongISOTime = () => {
    const now = new Date();
    const hongKongTime = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Hong_Kong" })
    );
    return hongKongTime.toISOString();
  };

  const handleSubmit = async (values) => {
    console.log("Formvalues", values);
    toggleLoader(true);
    try {
      const formattedTime = values?.time
        ? moment(values?.time).format("HH:mm:ss")
        : null;

      const payload = {
        departmentType: values?.departmentType, 
        clientId: ClientId,
        userId: userInfo?.userid,
        type: values?.type,
        name: filteruser[0]?.fullname,
        employeeId: filteruser[0]?.employeeid,
        date: values?.date.format("YYYY-MM-DD"),
        time: values?.time.format("HH:mm:ss"),
        incidentlocation: values?.incidentlocation,
        description: values?.description,
        insertedby: userInfo?.insertedby,
        evidence: fileData
          ? fileData.map((item) => ({
              fileName: item.name,
              contentType: item.fileType,
              base64Data: item.base64,
            }))
          : null,
        status: "Waiting for Review",
        actiontimeline: [
          {
            insertedAt: new Date().toISOString(),
            insertedby: userInfo?.userid,
            comment: values?.comment,
            actionmoveon: values?.actionmoveon,
          },
        ],
        insertedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };

      const payloadpatch = {
        departmentType: values?.departmentType, 
        clientId: ClientId,
        userId: details?.userId,
        name: details?.name,
        employeeId: details?.employeeId,
        type: values?.type,
        date: values?.date.format("YYYY-MM-DD"),
        time: formattedTime,
        incidentlocation: values?.incidentlocation,
        description: values?.description,
        insertedby: userInfo?.insertedby,
        actiontimeline: details?.actiontimeline,
        insertedAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        status: details?.status,
        evidence: fileData
          ? fileData.map((item) => ({
              fileName: item.name,
              contentType: item.fileType,
              base64Data: item.base64,
            }))
          : details?.evidence || null,
      };

      let response;
      if (details && Object.keys(details).length > 0) {
        response = await CALL_API(
          `incident/${ClientId}/${details?.incidentId}`,
          "patch",
          payloadpatch
        );
        closeModal(false);
        setIsSavedModalOpen(true);
        setTimeout(() => {
          setIsSavedModalOpen(false);
          closeModal(false);
        }, 2000);
        history.push("/myincident");
      } else {
    response = await CALL_API("incident", "post", payload);
        resetForm();
        closeModal(false);
        setIsSavedModalOpen(true);
        setTimeout(() => {
          setIsSavedModalOpen(false);
          if (page === "myincident") {
            history.push("/myincident");
          }
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error(t("Failed to submit the incident. Please try again."));
    } finally {
      toggleLoader(false);
    }
  };

  const handleRemove = () => {
    setFileData(null);
  };

  return (
    <>
      <StyledModal
        title={
          details && Object.keys(details).length > 0
            ? t("Editing Incident")
            : t("Reporting Incident")
        }
        visible={isModalVisible}
        onCancel={() => {
          resetForm();
          closeModal(false);
        }}
        width={600}
        footer={[]}
      >
        <Form
          form={form}
          name="incidentform"
          layout="vertical"
          initialValues={{
            incidentId: selectedIncidentId || "",
            type: "",
            incidentlocation: "",
            date: momentDate(getKenyanDateTime()),
            time: "",
            description: "",
            remark: "",
          }}
          onFinish={handleSubmit}
        >
          <Row gutter={20}>
             <Col xs={24} sm={24} md={12} ><Form.Item
  label={t("Department Type")}
  name="departmentType"
  rules={[
    {
      required: true,
      message: t("Department Type is required"),
    },
  ]}
>
  <StyledSelect
    showSearch
    placeholder={t("Department Type")}
    optionFilterProp="value"
    options={Object.keys(departmentCategoryMap).map((department) => ({
      value: department,
    }))}
    fieldNames={{ label: "value", value: "value" }}
    getPopupContainer={() => containerRef.current}
    onChange={(value) => {
      form.setFieldsValue({ type: "" }); // Clear Incident Type

      const category = departmentCategoryMap[value];

      setIncidentTypeOption(departmentIncidents[category] || []);
    }}
  />
</Form.Item></Col>

            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label={t("Incident Type")}
                name="type"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: t("Incident type is required"),
                  },
                ]}
              >
                <StyledSelect
                  showSearch
                  placeholder={t("Incident Type")}
                  optionFilterProp="value"
                  options={incidentTypeOption.map((val, index) => ({
  id: index,
  value: val,
}))}
                  fieldNames={{ label: "value", value: "value" }}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="incidentlocation"
                label={t("Incident Location")}
                rules={[
                  {
                    required: true,
                    message: t("Incident Location is required"),
                  },
                ]}
              >
                <StyledInput type="text" placeholder="" maxLength={50} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} ref={containerRef}>
              <Form.Item
                label={t("Select the date")}
                name="date"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: t("Date is required"),
                  },
                ]}
              >
                <DatePicker
                  className="form-datepicker"
                  format="DD-MM-YYYY"
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} ref={containerRef}>
              <Form.Item
                label={t("Time")}
                name="time"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: t("Time is required"),
                  },
                ]}
              >
                <TimePicker
                  defaultOpenValue={moment("00:00:00", "HH:mm:ss")}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} ref={containerRef}>
              <Form.Item
                className="mb-0 pb-0"
                label={t("Detailed Description")}
                name="description"
                rules={[
                  {
                    required: true,
                    pattern: NON_EMPTY_REGEX,
                    message: t("Description is required"),
                  },
                ]}
              >
                <StyledTextArea
                  placeholder={t("Type something")}
                  maxLength={250}
                  autoSize={{ minRows: 2, maxRows: 6 }}
                />
              </Form.Item>
              <span>
                <small className="small-text">
                  {t("Maximum 250 characters")}
                </small>
              </span>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                className="w-100 mt-2"
                label={t("Attachment (Optional)")}
                name="attachment"
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "8px",
                    border: "1px solid #D0D5DD",
                    padding: "12px",
                    borderRadius: "8px",
                    background: "#E8EDFD",
                  }}
                >
                  {fileData.length === 0 ? (
                    <Upload
                      customRequest={({ file, onSuccess, onError }) => {
                        const maxSize = 25 * 1024 * 1024;
                        if (file.type === "video/mp4") {
                          message.error(t("MP4 video files are not allowed"));
                          onError?.(t("MP4 video files are not allowed"));
                          return;
                        }
                        if (file.size > maxSize) {
                          message.error(t("File size should not exceed 25MB"));
                          onError?.(t("File size should not exceed 25MB"));
                          return;
                        }
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => {
                          const base64Data = reader.result.split(",")[1];
                          onSuccess?.();
                          setFileData((prev) => [
                            ...(Array.isArray(prev) ? prev : []),
                            {
                              base64: base64Data,
                              fileType: file.type,
                              name: file.name,
                            },
                          ]);
                        };
                        reader.onerror = (error) => {
                          console.error("File read error:", error);
                          message.error(t("File read error"));
                          onError?.(t("File read error"));
                        };
                      }}
                      showUploadList={false}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          cursor: "pointer",
                          marginRight: "450px",
                          height: "12px",
                        }}
                      >
                        <Fileupload
                          style={{
                            fontSize: "24px",
                            position: "relative",
                            color: "#4759C4",
                            marginBottom: "0px",
                            marginRight: "5px",
                          }}
                        />
                        <span
                          style={{
                            color: "#4759C4",
                            fontWeight: "500",
                            fontSize: "14px",
                            marginTop: "5px",
                          }}
                        >
                          {t("Upload File")}
                        </span>
                      </div>
                    </Upload>
                  ) : (
                    <>
                      {fileData.map((file, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#fff",
                            padding: "8px",
                            borderRadius: "6px",
                          }}
                        >
                          <span style={{ color: "#000", fontSize: "14px" }}>
                            {file.name}
                          </span>
                          <CloseOutlined
                            style={{
                              fontSize: "14px",
                              color: "#6E6E6E",
                              marginLeft: "8px",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setFileData((prev) =>
                                prev.filter((_, i) => i !== index)
                              );
                            }}
                          />
                        </div>
                      ))}
                      <Upload
                        customRequest={({ file, onSuccess, onError }) => {
                          const maxSize = 25 * 1024 * 1024;
                          if (file.type === "video/mp4") {
                            message.error(t("MP4 video files are not allowed"));
                            onError?.(t("MP4 video files are not allowed"));
                            return;
                          }
                          if (file.size > maxSize) {
                            message.error(
                              t("File size should not exceed 25MB")
                            );
                            onError?.(t("File size should not exceed 25MB"));
                            return;
                          }
                          const reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess?.();
                            setFileData((prev) => [
                              ...(Array.isArray(prev) ? prev : []),
                              {
                                base64: base64Data,
                                fileType: file.type,
                                name: file.name,
                              },
                            ]);
                          };
                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                            message.error(t("File read error"));
                            onError?.(t("File read error"));
                          };
                        }}
                        showUploadList={false}
                      >
                        <Button
                          icon={<PlusOutlined style={{ color: "blue" }} />}
                          style={{
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid rgb(228, 231, 243)",
                            borderRadius: "6px",
                          }}
                        />
                      </Upload>
                    </>
                  )}
                </div>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <div className="divstyl">
                <ButtonOutlined
                  type="primary"
                  onClick={() => {
                    resetForm();
                    closeModal(false);
                  }}
                >
                  {t("Cancel")}
                </ButtonOutlined>
                <ButtonFilled
                  className="m-0"
                  style={{ height: "32px" }}
                  loading={showLoader}
                  type="primary"
                  htmlType="submit"
                >
                  {details && Object.keys(details).length > 0
                    ? t("Save Changes")
                    : t("Submit")}
                </ButtonFilled>
              </div>
            </Col>
          </Row>
        </Form>
      </StyledModal>
      <StyledModal
        width={220}
        height={20}
        open={isSavedModalOpen}
        onCancel={() => setIsSavedModalOpen(false)}
        footer={false}
        closable={false}
        style={{ marginTop: "130px" }}
      >
        <div className="success-modal">
          <Tick />
          <p className="sent-successfully">
            {details && Object.keys(details).length > 0
              ? t("Saved")
              : t("Submitted")}
          </p>
        </div>
      </StyledModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  leaveCategoryList: getLeaveCategoryList(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  AllDepartmentList: getAllDepartmentList(state),
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  userList: getUserList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  leaveList: getLeaveList(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLeaveListData: setLeaveList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LeaveForm);